module.exports = __webpack_public_path__ + "img/oaFlowData160@3x.31cbb584.png";